import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/lib/Api";
import AsyncLocalStorage from "@createnextapp/async-local-storage";

const initialState = {
  token: null,
  refreshToken: null,
  userRole: null,
  userUrl: [],
};
export const setUser = createAsyncThunk(
  "user/setUser",
  async (payload, { getState }) => {
    const userObject = JSON.stringify(payload);
    await AsyncLocalStorage.setItem("userObject", userObject);
    api.setToken(payload.token);
    return payload;
  }
);
export const restoreUser = createAsyncThunk(
  "user/restoreUser",
  async (payload, { getState }) => {
    const userObjectStorgae = await AsyncLocalStorage.getItem("userObject");

    let userObject = initialState;
    if (userObjectStorgae) {
      userObject = JSON.parse(userObjectStorgae);
    }
    // localStorage.setItem("userObject", userObject);
    return userObject;
  }
);

export const removeUser = createAsyncThunk(
  "user/removeUser",
  async (payload, { getState }) => {
    await AsyncLocalStorage.removeItem("userObject");
    api.setToken();
    return payload;
  }
);
export const systemSlice = createSlice({
  name: "user",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(setUser.fulfilled, (state, action) => {
      return action.payload;
    });
    builder.addCase(removeUser.fulfilled, (state, action) => {
      return initialState;
    });
    builder.addCase(restoreUser.fulfilled, (state, action) => {
      return action.payload;
    });
  },
});

// Action creators are generated for each case reducer function
// export const { setPermission } = systemSlice.actions;

export default systemSlice.reducer;
